import React from "react";
import FaqAddContainer from "../../containers/Faq/FaqAddContainer";

const FaqAdd = (props) => {
  return (
    <>
      <FaqAddContainer {...props} />
    </>
  );
};

export default FaqAdd;
